export class LocalStorageService {
  static set(key: LocalStorageKey, value: any) {
    if (typeof value !== "string") {
      value = JSON.stringify(value);
    }
    localStorage.setItem(key, value);
  }

  static get(key: LocalStorageKey) {
    return localStorage.getItem(key);
  }

  static remove(key: LocalStorageKey) {
    localStorage.removeItem(key);
  }
}

export enum LocalStorageKey {
  LOGGED_IN_USER = "loggedInUser",
  ONBOARDING_SHOWN = 'onboardingShown'
}
